(() => {
  const SECTION_TYPE = 'sitemap';
  const MOBILE_MAX = 899;

  const initAccordion = (container) => {
    if (!container) return;

    const items = container.querySelectorAll('.sitemap-accordion__item');
    items.forEach((item) => {
      const header = item.querySelector('.sitemap-accordion__header');
      if (!header) return;

      header.addEventListener('click', () => {
        if (window.innerWidth > MOBILE_MAX) return;
        const isOpen = item.classList.toggle('is-open');
        header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach(initAccordion);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.dataset?.sectionType !== SECTION_TYPE) return;
    initAccordion(event.target);
  });
})();
